import { muiSurfaceBorderColor } from "themes/shared/surfaceBorder";

// ==============================|| OVERRIDES - TABLE HEAD ||============================== //

export default function TableHead(theme) {
  const borderColor = muiSurfaceBorderColor(theme, "table");

  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          borderTop: "none",
          borderBottom: "2px solid",
          borderBottomColor: borderColor,
        },
      },
    },
  };
}
